module.exports = __webpack_public_path__ + "2a37e440fd3783549a63e4ec2eabe836.svg";